"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOpeningImageTimeTakenUser = exports.updateFeatureInput = exports.deleteOpeningSuggestion = exports.updateOpeningSuggestion = exports.addOpeningSuggestion = exports.deleteFileAccess = exports.addFileAccess = exports.updateAccessPolicy = exports.setOutputOption = exports.updateFileName = exports.saveFile = void 0;
const Sentry = __importStar(require("@sentry/react"));
const immer_1 = require("immer");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const saveUtils_1 = require("../../client/saveUtils");
const messageReducer_1 = require("../shared/messageReducer");
const MapmakerApi_1 = require("../../client/MapmakerApi");
const serverFileReducer_1 = require("./serverFileReducer");
const core_1 = require("@mapmaker/core");
const gtm_1 = require("../../lib/gtm");
function getInitialFileState(file) {
    return Object.assign(Object.assign({}, file), { isDirty: false, saving: false, updateErrorCounter: 0 });
}
const UPDATE_FILE_START = "file.update_file_start";
const UPDATE_FILE_FAILED = "file.update_file_failed";
const ADD_FILE_ACCESS = "file.update_file_accesses";
const DELETE_FILE_ACCESS = "file.delete_file_accesses";
const ADD_OPENING_SUGGESTION = "file.add_opening_suggestion";
const UPDATE_OPENING_SUGGESTION = "file.update_opening_suggestion";
const DELETE_OPENING_SUGGESTION = "file.delete_opening_suggestion";
const UPDATE_FILE_NAME = "file.update_file_name";
const UPDATE_ACCESS_POLICY = "file.update_access_policy";
const SET_OUTPUT_OPTION = "file.project_output_type";
const UPDATE_FEATURE_INPUT = "file.update_feature_input";
const UPDATE_TIME_TAKEN_USER = "file.update_time_taken_user";
function saveFile(force = false) {
    return function save(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = getState();
            if (state.file.viewerPolicy != MapmakerApi_1.MapmakerFileViewerPolicy.Owner) {
                return;
            }
            console.info(`Begin save. File Updated at: ${state.file.updatedAt}`);
            // If we're already saving something bail out now.
            if (state.file.saving) {
                console.info("Skipping save because save already in progress.");
                return;
            }
            // If any images are still uploading we don't want to save them yet. Saving an incomplete image
            // causes problems if the upload fails.
            const incompleteUploads = state.uploads.filter((upload) => upload.status !== "COMPLETED");
            const inputsToSave = removeUploadingImages(state.file.inputs, incompleteUploads);
            const featureInputsHaveChanged = !(0, fast_deep_equal_1.default)(inputsToSave, state.serverFile.inputs);
            // If the state equals what the server has then we don't need to update.
            if (!force && !state.file.isDirty) {
                console.info("Skipping save because no changes were detected.");
                return;
            }
            dispatch(updateFileStart());
            try {
                const updatedFile = yield (0, saveUtils_1.updateFile)({
                    fileId: state.file.id,
                    fileUpdatedAt: state.file.updatedAt,
                    name: state.file.name,
                    outputType: state.file.outputType,
                    outputScale: state.file.outputScale,
                    accessPolicy: state.file.accessPolicy,
                    inputs: featureInputsHaveChanged ? inputsToSave : undefined,
                });
                console.info(`File ${state.file.id} saved.`);
                dispatch((0, serverFileReducer_1.fileLoadedFromServer)(updatedFile));
            }
            catch (e) {
                console.warn(`Save file failed. State's File updated at: ${state.file.updatedAt}`);
                Sentry.captureException(e);
                dispatch((0, messageReducer_1.addMessage)({
                    type: "error",
                    content: `File failed to save: ${e.message}`,
                }));
                dispatch(updateFileFailed());
            }
        });
    };
}
exports.saveFile = saveFile;
function removeUploadingImages(inputs, uploads) {
    const mapped = (0, core_1.mapOpeningImages)({ inputs }, (image) => {
        const upload = uploads.find((upload) => upload.key === image.id);
        if (upload && upload.status !== "COMPLETED") {
            return;
        }
        return image;
    }, "ALLOW_DELETION");
    return mapped.inputs;
}
function updateFileStart() {
    return {
        type: UPDATE_FILE_START,
    };
}
function updateFileFailed() {
    return {
        type: UPDATE_FILE_FAILED,
    };
}
function updateFileName(name) {
    return {
        type: UPDATE_FILE_NAME,
        name,
    };
}
exports.updateFileName = updateFileName;
function setOutputOption(outputOption) {
    return {
        type: SET_OUTPUT_OPTION,
        outputOption,
    };
}
exports.setOutputOption = setOutputOption;
function updateAccessPolicy(accessPolicy) {
    return {
        type: UPDATE_ACCESS_POLICY,
        accessPolicy,
    };
}
exports.updateAccessPolicy = updateAccessPolicy;
function addFileAccess(fileAccess) {
    return {
        type: ADD_FILE_ACCESS,
        fileAccess,
    };
}
exports.addFileAccess = addFileAccess;
function deleteFileAccess(fileAccess) {
    return {
        type: DELETE_FILE_ACCESS,
        fileAccess,
    };
}
exports.deleteFileAccess = deleteFileAccess;
function addOpeningSuggestion(openingSuggestion) {
    return {
        type: ADD_OPENING_SUGGESTION,
        openingSuggestion,
    };
}
exports.addOpeningSuggestion = addOpeningSuggestion;
function updateOpeningSuggestion(openingSuggestion) {
    return {
        type: UPDATE_OPENING_SUGGESTION,
        openingSuggestion,
    };
}
exports.updateOpeningSuggestion = updateOpeningSuggestion;
function deleteOpeningSuggestion(openingSuggestionId) {
    return {
        type: DELETE_OPENING_SUGGESTION,
        openingSuggestionId,
    };
}
exports.deleteOpeningSuggestion = deleteOpeningSuggestion;
function updateFeatureInput(featureId, featureInput) {
    return {
        type: UPDATE_FEATURE_INPUT,
        featureId,
        featureInput,
    };
}
exports.updateFeatureInput = updateFeatureInput;
function updateOpeningImageTimeTakenUser(openingId, imageId, timeTakenUser) {
    return {
        type: UPDATE_TIME_TAKEN_USER,
        openingId,
        imageId,
        timeTakenUser,
    };
}
exports.updateOpeningImageTimeTakenUser = updateOpeningImageTimeTakenUser;
function createFileReducer(file) {
    return (0, immer_1.produce)((draft, action) => {
        if (draft === undefined) {
            return getInitialFileState(file);
        }
        switch (action.type) {
            // Whenever the file is reloaded from the server we want to update most of the state right
            // away to avoid drift. However, we don't want to overwrite changes that were/are being made
            // by the user at that moment.
            case serverFileReducer_1.FILE_LOADED_FROM_SERVER:
                draft.saving = false;
                draft.updateErrorCounter = 0;
                draft.id = action.file.id;
                draft.name = action.file.name;
                draft.accessPolicy = action.file.accessPolicy;
                draft.viewerPolicy = action.file.viewerPolicy;
                draft.fileAccesses = action.file.fileAccesses;
                // TODO - Merge inputs in case things were changed elsewhere?
                //draft.inputs = action.file.inputs;
                draft.createdAt = action.file.createdAt;
                draft.updatedAt = action.file.updatedAt;
                console.info(`Setting local file's updatedAt to: ${draft.updatedAt}`);
                break;
            case UPDATE_FILE_START:
                draft.isDirty = false;
                draft.saving = true;
                break;
            case UPDATE_FILE_FAILED:
                draft.isDirty = true;
                draft.saving = false;
                draft.updateErrorCounter++;
                break;
            case UPDATE_FILE_NAME:
                draft.isDirty = true;
                draft.name = action.name;
                break;
            case SET_OUTPUT_OPTION:
                draft.isDirty = true;
                draft.outputType = action.outputOption.type;
                draft.outputScale = action.outputOption.scale;
                Object.entries(action.outputOption.inputs).forEach(([featureId, featureInput]) => {
                    draft.inputs[featureId] = featureInput;
                });
                break;
            case UPDATE_ACCESS_POLICY:
                draft.isDirty = true;
                draft.accessPolicy = action.accessPolicy;
                (0, gtm_1.trackGtmEvent)({
                    event: "mapmaker.change-project-access-policy",
                    policy: action.accessPolicy,
                });
                break;
            case ADD_FILE_ACCESS:
                draft.fileAccesses.push(action.fileAccess);
                break;
            case DELETE_FILE_ACCESS:
                draft.fileAccesses = draft.fileAccesses.filter((fileAccess) => fileAccess.id !== action.fileAccess.id);
                break;
            case ADD_OPENING_SUGGESTION:
                draft.openingSuggestions.push(action.openingSuggestion);
                break;
            case UPDATE_OPENING_SUGGESTION:
                draft.openingSuggestions = draft.openingSuggestions.map((suggestion) => {
                    if (suggestion.id === action.openingSuggestion.id) {
                        return action.openingSuggestion;
                    }
                    else {
                        return suggestion;
                    }
                });
                break;
            case DELETE_OPENING_SUGGESTION:
                draft.openingSuggestions = draft.openingSuggestions.filter((suggestion) => suggestion.id !== action.openingSuggestionId);
                break;
            case UPDATE_FEATURE_INPUT:
                draft.isDirty = true;
                draft.inputs[action.featureId] = Object.assign({}, action.featureInput);
                draft.inputs[action.featureId].modifiedAt = new Date().toISOString();
                break;
            case UPDATE_TIME_TAKEN_USER:
                const feature = draft.inputs[action.openingId];
                if (feature.type === "OPENING") {
                    draft.isDirty = true;
                    feature.modifiedAt = new Date().toISOString();
                    feature.images.forEach((image) => {
                        if (image.id === action.imageId || !action.imageId) {
                            image.timeTakenUser = action.timeTakenUser;
                        }
                    });
                }
                break;
            default:
                return draft;
        }
    });
}
exports.default = createFileReducer;
//# sourceMappingURL=data:application/json;base64,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